import utils from 'helpers/utils';

export default (function () {
    const types = [
        'accommodation',
        'airport',
        'bridge',
        'beach',
        'business_centre',
        'city',
        'cultural',
        'education',
        'event',
        'event_center',
        'government_building',
        'hospital',
        'library',
        'museum',
        'neighbourhood',
        'other',
        'park',
        'port',
        'recreation',
        'religious_building',
        'restaurant',
        'shopping_centre',
        'sight',
        'station',
    ];

    return {
        getLabeledTypes: () => {
            return utils.map(types, (type) => {
                return {
                    id: type,
                    name: `resources.points_of_interest.types.${ type }`,
                };
            });
        },
    };
}());



// WEBPACK FOOTER //
// ./src/helpers/pointsOfInterest.js